import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n.js';
import './index.css';
import App from './App.js';
import { DemoModeProvider } from './context/DemoModeContext.js';
import { LocaleProvider } from './context/LocaleContext.js';
import { ToastProvider } from './components/ui/toast.js';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <DemoModeProvider>
      <LocaleProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </LocaleProvider>
    </DemoModeProvider>
  </StrictMode>,
);
